import React from 'react'
import { string, bool } from 'prop-types'
import { css } from '@emotion/react'

import ProductBadge from '@/components/Product/Badges/ProductBadge'
import { PRODUCT_BADGES } from '@/components/Product/Badges'
import { isVerifiedApp } from '@/store/selectors'
import useParamSelector from '@/hooks/useParamSelector'

const badgeCss = ({ colors }) => css`
  top: 1px;
  padding-inline: 8px;
  color: ${colors.black700};
`
const Badge = ({ id, noVerified, withAiBadge }) => {
  const isVerified = useParamSelector(isVerifiedApp, id)

  if (withAiBadge) {
    return <ProductBadge {...PRODUCT_BADGES.aiPowered} css={badgeCss} />
  }

  if (!noVerified && isVerified) {
    return <ProductBadge {...PRODUCT_BADGES.verified} css={badgeCss} />
  }

  return null
}

Badge.propTypes = {
  id: string,
  noVerified: bool,
  withAiBadge: bool,
}

export default Badge
